module.exports = __webpack_public_path__ + "static/learning-extension-69033938eb1fba28b852ffb14db3c929.jpg";